const JOB_FIELDS = {
  NOTES: 'notes',
  ISSUE_TYPE: 'issueType',
};

export default JOB_FIELDS;
